import { render, staticRenderFns } from "./ActivitiesView.vue?vue&type=template&id=0df332f7"
import script from "./ActivitiesView.vue?vue&type=script&lang=ts"
export * from "./ActivitiesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports